// Canonical domain-code → display-word mapping. Single source of truth
// for the user-facing vocabulary: BIO renders as "Body", PSYCH as
// "Mind", BEH as "Behavior" — never the clinical adjective forms and
// never the old utils-layer BEH word. Guarded by domainLabels.test.js,
// which greps the source tree so the pre-sweep vocabulary can't return.
export const DOMAIN_WORD = { BIO: "Body", PSYCH: "Mind", BEH: "Behavior" };

// Array shape used by the score-breakdown components (RevealScreen,
// DomainSubScores): snapshot field prefix + per-domain AI label field.
// Display order is Mind, Body, Behavior everywhere in the app.
export const DOMAIN_META = [
  { key: "psych", code: "PSYCH", display: DOMAIN_WORD.PSYCH, labelField: "psych_label" },
  { key: "bio", code: "BIO", display: DOMAIN_WORD.BIO, labelField: "bio_label" },
  { key: "beh", code: "BEH", display: DOMAIN_WORD.BEH, labelField: "beh_label" },
];
